const prefix = process.env.VUE_APP_API_URL + 'locale/'

export const getLocaleMessagesAPI = prefix + 'get-locale-messages'
